import { Flex } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import { REFERRAL_PAYOUT_AMOUNT_USD } from '../../../../constants/referral';
import {
  ReferrerAggregateGraphQlType,
  useGetReferrerAggregateLazyQuery,
} from '../../../../gql/generated/graphql';
import { formatMoney } from '../../../../utils/helpers';
import { Referrer } from '../../../../utils/types/referrer';

const Metrics = ({
  referrer,
  needInstrument,
  aggregate,
  setAggregate,
  owedAsRefereeCount,
}: {
  referrer: Referrer;
  aggregate: ReferrerAggregateGraphQlType | null;
  needInstrument: boolean;
  setAggregate: (val: ReferrerAggregateGraphQlType | null) => void;
  owedAsRefereeCount: number;
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [getReferrer] = useGetReferrerAggregateLazyQuery({
    context: { isErrorHandled: true },
  });
  const handleAggregate = async () => {
    setLoading(true);
    const data = await getReferrer({ variables: { referrer_id: referrer.id } });
    setAggregate(data.data?.getReferrerAggregate ?? null);
    setLoading(false);
  };
  useEffect(() => {
    if (referrer) {
      handleAggregate();
    }
  }, []);
  return (
    <Flex justifyContent="space-between" gap={2} mb={2}>
      <Flex
        flex={1}
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        borderRadius={6}
        bg="oceanBoatBlue"
        gap={1}
        color="#fff"
        py={4}
      >
        <Flex fontSize={11} textTransform="uppercase" alignItems="center" gap={1}>
          paid
        </Flex>
        <Flex lineHeight={1} fontSize={18} fontWeight={700} cursor="pointer">
          {loading ? (
            <>...</>
          ) : aggregate ? (
            `${formatMoney((aggregate.paid_referrals ?? 0) * REFERRAL_PAYOUT_AMOUNT_USD)}`
          ) : (
            <>Error</>
          )}
        </Flex>
      </Flex>
      <Flex
        flex={1}
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        bg={needInstrument ? '#fed7d7' : 'rgba(0,125,197,0.18)'}
        borderRadius={6}
        gap={1}
        color={needInstrument ? 'rgb(197, 48, 48)' : 'oceanBoatBlue'}
        py={4}
      >
        <Flex fontSize={11} textTransform="uppercase" alignItems="center" gap={1}>
          owed
        </Flex>
        <Flex lineHeight={1} fontSize={18} fontWeight={700}>
          {loading ? (
            <>...</>
          ) : aggregate ? (
            `${formatMoney(
              ((aggregate.owed_referrals ?? 0) + owedAsRefereeCount) * REFERRAL_PAYOUT_AMOUNT_USD,
            )}`
          ) : (
            <>Error</>
          )}
        </Flex>
      </Flex>
      <Flex
        flex={1}
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        bg="rgba(0,125,197,0.18)"
        borderRadius={6}
        gap={1}
        color="oceanBoatBlue"
        py={4}
      >
        <Flex fontSize={11} textTransform="uppercase" alignItems="center" gap={1}>
          pending
        </Flex>
        <Flex lineHeight={1} fontSize={18} fontWeight={700} color="oceanBoatBlue">
          {loading ? (
            <>...</>
          ) : aggregate ? (
            `${formatMoney((aggregate.pending_referrals ?? 0) * REFERRAL_PAYOUT_AMOUNT_USD)}`
          ) : (
            <>Error</>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};
export default Metrics;
